import React, { useEffect, useState } from 'react'
import './Download_Component.css'
import RedRoundBtn from '../../../Common_Btn/RedRoundBtn/RedRoundBtn'
import { faDownload, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Accordion } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getData } from '../../../../../utils/api'

const Download_Component = ({val,IMG_URL,...props}) => {

    const handleDownload = () => {
        const brochureUrl = `${IMG_URL}${val?.brochure}`;
        window.open(brochureUrl, "_blank");
      };
      const [FAQ, setFAQ] = useState([]);
      const GetFAQ = async () => {
        const response = await getData(`/finance/home/f-faq`);
        if (response?.success) {
            setFAQ(response?.data);
        }
      };
      useEffect(() => {
        GetFAQ();
      
      }, []);
    return (
        <div className='Download_Component'>

            <div className='downoad_div'>
                <div className='left_side'>
                    <div className='img_holder'>
                        <img src='\assets\Image\Plan_Details\download\pdf.png' className='img' />
                    </div>

                    <div className='text_holder'>
                        <p className='heading_text'>
                            Brochure
                        </p>
                        <p className='subheading_text'>
                            This will help you understand plan in detail.
                        </p>
                    </div>

                </div>

                <div className='btn_holder' onClick={handleDownload}>
                    <button className="DownloadBtn" onClick={props?.onClick} type='button'>
                        <div className='icon_holder'>
                            <FontAwesomeIcon icon={faDownload} className='lefticon' />
                        </div>
                        <p className='btn_text'>{"Download"}</p>
                    </button>
                </div>

            </div>


            <div className='faq_main_section'>
                <div className="faq_heading">
                    <h1>FAQs</h1>
                </div>

                <div className="faq_main_div">

                    <Accordion defaultActiveKey={0} flush>
                        {FAQ?.map((val,index)=>
                        <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                                <div className='question_div'>
                                    <p className='question'>{val?.name}</p>
                                </div>

                                <div className='icon_holder minus_icon'>
                                    <FontAwesomeIcon icon={faMinus} className='icon' />
                                </div>
                                <div className='icon_holder plus_icon'>
                                    <FontAwesomeIcon icon={faPlus} className='icon' />
                                </div>

                            </Accordion.Header>
                            <Accordion.Body>
                                <p className='answer'>{val?.description}</p>
                            </Accordion.Body>
                        </Accordion.Item>)}

                        {/* <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                <div className='question_div'>
                                    <p className='question'>Why should I buy Term Insurance?</p>
                                </div>

                                <div className='icon_holder minus_icon'>
                                    <FontAwesomeIcon icon={faMinus} className='icon' />
                                </div>
                                <div className='icon_holder plus_icon'>
                                    <FontAwesomeIcon icon={faPlus} className='icon' />
                                </div>

                            </Accordion.Header>
                            <Accordion.Body>
                                <p className='answer'>term insurance plan not only offers a financial safety net to your family against
                                    day to day expenses, loans, liabilities, EMIs etc but is also capable of fulfilling its future needs such as your child's higher education, child's marriage, etc. Among all the life insurance products,
                                    term life insurance offers the highest life coverage for the minimal premiums.</p>
                            </Accordion.Body>
                        </Accordion.Item> */}

                    </Accordion>

                 
                </div>
            </div>


        </div>
    )
}

export default Download_Component
